// Path: libs/core/shell/src/lib/layout/public/hero/public-hero-state.service.ts
import { Injectable, signal } from '@angular/core';

export interface PublicHeroPromoItem {
  id: string;
  title: string;
  description?: string | null;
  badge?: string | null;
  price?: number | null;
  compareAtPrice?: number | null;
  ctaLabel?: string | null;
  imageUrl?: string | null;
  imageAlt?: string | null;
}

export interface PublicHeroCategoryItem {
  id: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class PublicHeroStateService {
  private readonly _promos = signal<PublicHeroPromoItem[]>([]);
  private readonly _searchTerm = signal('');
  private readonly _categories = signal<PublicHeroCategoryItem[]>([]);

  readonly promos = this._promos.asReadonly();
  readonly searchTerm = this._searchTerm.asReadonly();
  readonly categories = this._categories.asReadonly();

  setPromos(items: PublicHeroPromoItem[]): void {
    this._promos.set((items ?? []).slice(0, 3));
  }

  clearPromos(): void {
    this._promos.set([]);
  }

  setSearchTerm(term: string): void {
    this._searchTerm.set((term ?? '').trim());
  }

  clearSearchTerm(): void {
    this._searchTerm.set('');
  }

  setCategories(items: PublicHeroCategoryItem[]): void {
    this._categories.set(items ?? []);
  }

  clearCategories(): void {
    this._categories.set([]);
  }
}
